<h3
  class="inline-block bg-[--color-background-tertiary] leading-4 pr-3 py-1 rounded-tr-full rounded-br-full -ml-3 pl-3 mb-4"
>
  @if (icon()) {
    <lib-svg class="inline-block [&_svg]:w-5 [&_svg]:h-5 align-middle mr-2" [svg]="icon()" />
  }
  <span class="text-[--color-text-primary] text-xs font-bold align-middle"><ng-content /></span>
</h3>
